import * as Yup from 'yup';

export const setUpYup = () => {
    Yup.setLocale({
        mixed: {
            required: 'This field is required',
        },
    });
};

// yup.addMethod(Yup.date, 'format', function (formats, parseStrict) {
//     return this.transform(function (value, originalValue) {
//       if (this.isType(value)) return value;

//       value = Moment(originalValue, formats, parseStrict);

//       return value.isValid() ? value.toDate() : new Date('');
//     });
//   });

// Yup.addMethod(Yup.string, 'emptyToNull', function (formats, parseStrict) {
//     return this.transform(function (value, originalValue) {
//         console.log('new tester', value, this.isType(value));
//         if (this.isType(value)) {
//             return value;
//         }

//         return null;
//     });
// });

// module 'yup' {
//     declare StringSchema {
//         emptyToNull:
//     }
// }

// globals.d.ts
// declare module 'yup' {
//     interface StringSchema<TType, TContext, TDefault, TFlags> {
//       append(appendStr: string): this;
//     }
//   }

//   // app.ts
//   import { addMethod, string } from 'yup';

//   addMethod(string, 'append', function append(appendStr: string) {
//     return this.transform((value) => `${value}${appendStr}`);
//   });
